import cls from 'classnames';
import React from 'react';

import DialogFooterButton from '../../common/dialog-button';

export interface IProps {
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  value?: string;

  onPress?: () => void;
}

const DialogFooterCancel: React.FC<IProps> = ({
  className: pClassName,
  disabled,
  loading,
  value,
  onPress
}) => {
  const className = React.useMemo(() => {
    return cls('btn', pClassName, {
      'opacity-50 cursor-default': disabled,
      'ml-3': !pClassName?.includes('m')
    });
  }, [pClassName, disabled]);

  return (
    <DialogFooterButton
      className={className}
      disabled={disabled}
      loading={loading}
      onPress={onPress}
    >
      {value}
    </DialogFooterButton>
  );
};

DialogFooterCancel.defaultProps = {
  value: 'Cancel'
};

export default DialogFooterCancel;
